import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../utils/store';

export interface UserProfile {
  id: number;
  name: string;
}

const initialState: UserProfile = {
  id: 0,
  name: '',
};

export const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    setUserID: (state, action: PayloadAction<number>) => {
      state.id = action.payload;
    },
    setUserName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
  },
});

export const { setUserID, setUserName } = userProfileSlice.actions;

export const selectUserName = (state: RootState) => state.userProfile.name;

export default userProfileSlice.reducer;
